import React      from 'react';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { BaseNotification } from './BaseNotification';

export default function SolicitudNotification({ notification, onDismiss }) {
  return (
    <BaseNotification
      notification={notification}
      onDismiss={onDismiss}
      icon={<SyncAltIcon style={{ fontSize: 18 }} />}
    />
  );
}
